<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <popUp v-if="addToggle" v-on:doClose="close" :size="'small'">
      <div class="pop-title" slot="title">
        <h3>新增班級</h3>
        <div class="d-flex align-items-center  mt-3">
          <label class="m-0 mr-2">班級名稱:</label>
          <input type="text" v-model="groupName">
        </div>
        <div class="my-2">
          <div class="d-flex align-items-center">
            <label class="m-0 mr-2">日期區間:</label>
            <date-picker valueType="format" v-model="range" :format="'YYYY-MM-DD HH:mm'" :showTimeHeader="true" type="datetime" :showSecond="false" range placeholder="請選擇日期區間"></date-picker>
          </div>
        </div>
        <div class="my-2" style="text-align: left;">
          <div class="d-flex align-items-center">
            <input type="checkbox" id="playableCheckbox" v-model="enable" :true-value="1"
            :false-value="0">
            <span class="ml-2" for="checkbox">啟用</span>
          </div>
        </div>
        <button style="float: right;" type="button" :disabled="!groupName" @click="addGroup" class="btn btn-danger">新增</button>
      </div>
    </popUp>
    <popUp v-if="modifyToggle" v-on:doClose="close" :size="'small'">
      <div class="pop-title" slot="title">
        <h3>修改班級</h3>
        <div class="d-flex align-items-center  mt-3">
          <label class="m-0 mr-2">班級名稱:</label>
          <input type="text" v-model="groupName">
        </div>
        <div class="my-2">
          <div class="d-flex align-items-center">
            <label class="m-0 mr-2">日期區間:</label>
            <date-picker valueType="format" v-model="range" :format="'YYYY-MM-DD HH:mm'" :showTimeHeader="true" type="datetime" :showSecond="false" range placeholder="請選擇日期區間"></date-picker>
          </div>
        </div>
        <div class="my-2" style="text-align: left;">
          <div class="d-flex align-items-center">
            <input type="checkbox" id="playableCheckbox" v-model="enable" :true-value="1"
            :false-value="0">
            <span class="ml-2" for="checkbox">啟用</span>
          </div>
        </div>
        <button style="float: right;" type="button" :disabled="!groupName" @click="modifyGroup" class="btn btn-danger">修改</button>
      </div>
    </popUp>
    <popUp v-if="addStudentToggle" v-on:doClose="close" :size="'small'">
      <div class="pop-title" slot="title">
        <h3>新增學生</h3>
        <div class="d-flex align-items-center mt-3">
          <label class="mr-2">姓名:</label>
          <input type="text" v-model="name" >
        </div>
        <div class="my-2">
          <div class="d-flex align-items-center">
            <label class="mr-2">信箱:</label>
            <input type="text" v-model="email">
          </div>
        </div>
        <span style="color: #F24949">
          {{ errorMessage }}
        </span>
        <button style="float: right;" type="button" :disabled="!name||!email||errorMessage!==''" @click="addStudent" class="btn btn-danger">新增</button>
      </div>
    </popUp>
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div class="title d-sm-flex pointer active" >
            <div class="my-auto">
              <span v-if="currentType === 'group'">
                班級列表
              </span>
              <span v-else>
                學生列表
              </span>
            </div>
          </div>
          <!-- <div @click="goTitlePage('Score')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Score'}">
            <div class="my-auto">
              考試成績
            </div>
          </div> -->
        </div>
      </div>
      <div class="col-12 mt-2" style="min-height:40vh">
        <div class="d-flex align-items-center justify-content-between" >
          <button v-if="currentType === 'group'" type="button" class="btn btn-danger" @click="addToggle=true">+ 新增班級</button>
          <button v-if="currentType === 'student'" type="button" class="btn btn-danger" @click="addStudentToggle=true">+ 新增學生</button>
          <div>
          <a download="匯入範本" class="mx-2" href="/files/import_example.xlsx">匯入範本</a>
          <button type="button" class="btn btn-danger" @click="triggerFileInput">匯入學生</button>
          <!-- 隱藏的檔案選擇器 -->
            <input type="file" ref="fileInput" @click="e => {e.target.value = ''}" @change="handleFileUpload" style="display:none"/>
          </div>
            <div v-if="excelData.length">
              <h2>Excel 內容</h2>
              <pre>{{ excelData }}</pre>
            </div>
        </div>
        <div v-if="currentType === 'group'">
          <table class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>班級名稱</th>
                <th>開始時間</th>
                <th>結束時間</th>
                <th>狀態</th>
                <th>人數</th>
                <th>修改</th>
              </tr>
              <tr v-for="(item, index) in groupList" :key="index">
                <td data-th="考場名稱" class="groupTitle pointer">
                  <span @click="goStudentList(item)">{{item.name}}</span>
                </td>
                <td data-th="開始時間">
                  {{item.begin_at}}
                </td>
                <td data-th="結束時間">
                  {{item.end_at}}
                </td>
                <td data-th="狀態">
                  {{item.is_enable ? '啟用': '未啟用'}}
                </td>
                <td data-th="人數">
                  {{item.student_count}}
                </td>
                <td data-th="修改">
                  <button type="button" class="btn btn-primary" @click="modifyGroupPop(item)">修改</button>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
        </div>
        <div v-else>
          <table v-if="studentList.length>0" class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>學生姓名</th>
                <th>刪除</th>
              </tr>
              <tr v-for="(item, index) in studentList" :key="index">
                <td data-th="學生姓名">
                  <span>{{item.name}}</span>
                </td>
                <td data-th="刪除">
                  <button type="button" @click="removeAlert(item.id)" class="btn btn-primary">刪除</button>
                </td>
              </tr>
            </tbody>
          </table>
          <h3 v-else>目前此班級並無學生</h3>
          <!-- <pagination v-if="StudentPageCount>1" class="m-auto pt-4" :current="StudentPageIndex" :total="StudentPageCount" v-on:page="toPage"/> -->
        </div>
      </div>
      <div>
        <button v-if="currentType==='student'" type="button" class="btn btn-danger" @click="back">返回</button>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import PopUp from '@/components/PopUp.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import api from '../../store/api'
export default {
  name: 'GroupManagement',
  data () {
    return {
      addToggle: false,
      modifyToggle: false,
      addStudentToggle: false,
      studentList: [],
      groupList: [],
      groupName: '',
      range: [],
      enable: 1,
      name: '',
      email:'',
      currentType: 'group',
      currentGroupId: '',
      inputRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      errorMessage: '',
      excelData: [],
      pageSize: 10,
      pageCount: 0,
      pageIndex: 1,
      StudentPageCount: 0,
      StudentPageIndex: 1
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    enterprisesId () {
      return this.$store.state.auth.enterpriseId
    }
  },
  components: {
    DatePicker,
    Pagination,
    PopUp
  },
  watch: {
    email(newValue) {
      // 監聽 inputValue 的變化並驗證
      if (newValue === '') {
        this.errorMessage = ''
      } else {
        if (!this.inputRegex.test(newValue)) {
        this.errorMessage = '輸入信箱格式不正確'
        } else {
          this.errorMessage = ''
        }
      }
    }
  },
  async mounted () {
    await this.getGroupList()
  },
  methods: {
    async getGroupList() {
      const params = {
        page: this.pageIndex,
        pageSize: 20
        // sort: 'desc'
      }
      const { data } = await api.get(`/groups`, { params })
      this.groupList = data.data
      this.page = data.pageIndex
      this.pageCount = data.pageCount
    },
    async getStudentList(id) {
      const params = {
        page: this.StudentPageIndex,
        pageSize: 500
      }
      const { data } = await api.get(`groups/${id}/students`, { params })
      this.studentList = data.data
      this.StudentPageIndex = data.pageIndex
      this.StudentPageCount = data.pageCount
    },
    async removeAlert (id) {
      let self = this
      self.$swal({
        title: '確認刪除?',
        text: '資料刪除後無法復原',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        closeOnConfirm: false
      }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          self.deleteStudent(id)
        }
      })
    },
    async deleteStudent(id) {
      const vm = this
      try {
        await api.delete(`students/${id}`)
        this.$swal({
          title: '刪除成功',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: '確定'
        }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          vm.getStudentList(vm.currentGroupId)
        }})
      } catch (error) {
        console.error(error.response.data)
        this.$swal({
          title: '刪除失敗',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
      }
    },
    async addGroup () {
      try {
        const fileData = new window.FormData()
        fileData.append('name', this.groupName)
        fileData.append('begin_at', this.range[0])
        fileData.append('end_at', this.range[1])
        fileData.append('is_enable', this.enable)
        const { data } = await api.post(`groups`, fileData)
        this.getGroupList()
        this.close()
      } catch (error) {
        this.$swal({
          title: '新增班級失敗',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        console.error(error.response.data)
      }
    },
    async modifyGroup () {
      try {
        const fileData = new window.FormData()
        fileData.append('name', this.groupName)
        fileData.append('begin_at', this.range[0])
        fileData.append('end_at', this.range[1])
        fileData.append('is_enable', this.enable)
        const { data } = await api.post(`groups/${this.currentGroupId}`, fileData)
        this.getGroupList()
        this.close()
      } catch (error) {
        this.$swal({
          title: '修改班級失敗',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        console.error(error.response.data)
      }
    },
    goStudentList (item) {
      this.currentType = 'student'
      this.currentGroupId = item.id
      this.getStudentList(item.id)
    },
    async addStudent () {
      const vm = this
      const password = vm.getEmailPrefix(vm.email)
      try {
        const fileData = new window.FormData()
        fileData.append('name', vm.name)
        fileData.append('email', vm.email)
        fileData.append('password', password)
        fileData.append('password_confirmation', password)
        fileData.append('group_id', vm.currentGroupId)
        await api.post(`students`, fileData)
        vm.getStudentList(vm.currentGroupId)
        vm.close()
      } catch (error) {
        this.$swal({
          title: '新增學生失敗',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        console.error(error.response.data)
      }
    },
    getEmailPrefix (email) {
      const atIndex = email.indexOf('@');
      if (atIndex === -1) {
        throw new Error('Invalid email format.')
      }
      return email.substring(0, atIndex)
    },
    modifyGroupPop (item) {
      this.currentGroupId = item.id
      this.groupName = item.name
      this.range = [item.begin_at,item.end_at ]
      this.enable= item.is_enable
      this.modifyToggle = true
    },
    reset () {
      this.currentGroupId = ''
      this.groupName = ''
      this.range = ['', '']
      this.enable = 1
      this.name = ''
      this.email = ''
      this.errorMessage = ''
    },
    close (close) {
      this.addToggle = close
      this.modifyToggle = close
      this.addStudentToggle = close
      this.reset()
    },
    back () {
      this.currentType = 'group'
      this.pageIndex = 1
    },
    async importExcel (file) {
      const vm = this
      const fileData = new FormData()
      fileData.append('file', file)
      try {
        await api.post(`enterprises/${this.enterprisesId}/import_students`, fileData)
        this.$swal({
          title: '匯入成功',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        vm.getGroupList()
      } catch (error) {
        this.$swal({
          title: '匯入失敗',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        console.error(error.response.data)
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const inputFile = this.$refs.fileInput.files[0]
      this.importExcel(inputFile)
    },
    toPage (toPage) {
      this.pageIndex = toPage
      if(this.currentType === 'group') {
        this.getGroupList()
      } else {
        this.getStudentList(this.currentGroupId)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/color.scss";
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  .pop-box {
    width: 500px !important;
  }
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .active {
    font-weight: bolder;
  }
  .groupTitle {
    text-decoration: underline;
  }
  .groupTitle:hover {
    color: #044ed6;
  }
  .sentencesActive {
    font-weight: bold;
    box-shadow: rgb(168, 168, 168) 5px 5px 15px;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
